<template>
  <ForgotPassword
    v-if="viewType === 'forgotPassword'"
    :user-email="email"
    @change-view="changeView"
  />

  <SignMeIn
    v-else-if="viewType === 'login'"
    @change-view="changeView"
  />

  <div
    v-else-if="viewType === 'thankYou'"
    class="pb-4"
  >
    <KikHeading
      :level="5"
      title="Check Your Inbox"
      :description="$t('forgotPasswordConfirmation', [email])"
    />
    <KikHeading
      :level="5"
      class="mb-2"
      title="No message received yet?"
    />
    <ul class="list-inside list-decimal font-light">
      <li>{{ $t('noMessageReceivedBullet1') }}</li>
      <li>{{ $t('noMessageReceivedBullet2') }}</li>
    </ul>

    <div class="absolute inset-x-0 -bottom-6 me-auto ms-auto w-[320px]">
      <div class="bg-neutral-50 text-center">
        <KikButton
          class="h-[48px] min-w-[280px]"
          variant="primary"
          data-testid="forgot-password__submit-btn"
          @click="changeView('login')"
        >
          <div>
            {{ $t('Go back') }}
          </div>
        </KikButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import SignMeIn from './fragments/SignMeIn.vue';
import ForgotPassword from './fragments/ForgotPassword.vue';

type ViewType = 'login' | 'forgotPassword' | 'thankYou';

const viewType = ref<ViewType>('login');
const email = ref<string>();

const changeView = (view: ViewType, currentEmail?: unknown) => {
  if (view === 'forgotPassword') {
    viewType.value = view;
    email.value = currentEmail as string;
    return;
  }
  email.value = currentEmail;
  viewType.value = view;
};
</script>
